export const isNullish = (value: any): boolean => value === null || value === undefined
